"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("@design/ui/button");
var _ArtifactLinkContext = require("./ArtifactLinkContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ArtifactLink = exports.ArtifactLink = function ArtifactLink(_ref) {
  var artifactId = _ref.artifactId,
    children = _ref.children;
  var openArtifact = (0, _ArtifactLinkContext.useOpenArtifact)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    variant: "link",
    onClick: function onClick() {
      return openArtifact(artifactId);
    },
    className: "h-auto whitespace-normal p-0 [font:inherit]",
    "data-sentry-element": "Button",
    "data-sentry-component": "ArtifactLink",
    "data-sentry-source-file": "ArtifactLink.tsx",
    children: children
  });
};